window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;


/**
 * Serialize all form data into a JSON string
 * @param {HTMLFormElement} form The form to serialize
 * @returns {String} The serialized form data
 */
function serializeFormToJSON (form) {
  // Create a new FormData object
  const formData = new FormData(form);

  // Create an object to hold the name/value pairs
  const pairs = {};

  // Add each name/value pair to the object
  for (const [name, value] of formData) {
    pairs[name] = value;
  }

  // Return the JSON string
  return JSON.stringify(pairs, null, 2);
}

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    },

    removeInvalidChars: function(str) {
      //function removeInvalidChars(str) {
      var newstr = str.replace(/([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g, '')
                      .replace(/(\r\n|\n|\r)/gm, "")
                      .replace(/<[^>]*>?/gm, '')
                      .replace("&", 'and');
      return newstr;
    }  
    
  };
  
  theme.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
  
      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });
  
      document.documentElement.on(eventsName.focusin, function(evt) {
  
        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        
        var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
        var elArray = [].slice.call(focusableEls);
        var focusableElements = elArray.filter(el => el.offsetParent !== null);

        var firstFocusable = focusableElements[0];
        var lastFocusable = focusableElements[focusableElements.length - 1];
        
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
        if (evt.target === lastFocusable && !evt.shiftKey ) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      document.documentElement.off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },
  
    unlockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };
  
  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });

  theme.Currency = (function() {
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;

    // Store conversion rates + formats
    var conversionRates = {};
    var moneyFormats = {};
    var shopCurrency = window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD';
    var userCurrency = localStorage.getItem('selectedCurrency') || shopCurrency;

    // Fetch conversion rates & formats from Shopify
    function loadConversionData(callback) {
      fetch('/currencies.js')
        .then(res => res.json())
        .then(data => {
          conversionRates = data.rates || {};
          moneyFormats = data.money_formats || {};
          if (callback) callback();
        })
        .catch(err => console.warn('Currency data not loaded', err));
    }

    // Convert cents into target currency
    function convertCents(cents, fromCurrency, toCurrency) {
      if (fromCurrency === toCurrency || !conversionRates[toCurrency]) {
        return cents; // no conversion
      }
      var rate = conversionRates[toCurrency] / conversionRates[fromCurrency];
      return Math.round(cents * rate);
    }

    function formatMoney(cents, format, currencyCode) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var targetCurrency = currencyCode || userCurrency;
      cents = convertCents(cents, shopCurrency, targetCurrency);

      // Use the correct money_format from Shopify if available
      var formatString = moneyFormats[targetCurrency] || theme.settings.moneyFormat || '${{amount}}';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var value = '';

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          if (superScript && value && value.includes('.')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) return;
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
      loadConversionData: loadConversionData,
      setCurrency: function(code) {
        userCurrency = code;
        localStorage.setItem('selectedCurrency', code);
      }
    }
  })();

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });
  
  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */
  
  theme.cart = {
    getCart: function() {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },
  
    getCartProductMarkup: function() {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
  
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
  
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(function(response) {
        return response.text();
      });
    },
  
    changeItem: function(key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },
  
    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function(cart) {
        return cart;
      });
    },
  
    updateAttribute: function(key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },
  
    updateNote: function(note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }
  
  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function() {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-cart__item_row', // '.js-qty__wrapper',
      //discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',
      subTotalPlusSavings: '[data-subtotal-plus-savings]',
      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout',
      mobileCheckoutButton: '.cart__checkout-mobile [data-sticky-checkout-btn]',
      desktopCheckoutButton: '.cart__checkout-desktop [data-sticky-checkout-btn]',
      kits: '.cart-kits',
      addons: '.cart-addons'
    };
  
    var classes = {
      btnLoading: 'btn--loading'
    };
  
    var config = {
      requiresTerms: false
    };
  
    function CartForm(form) {
      if (!form) {
        return;
      }
  
      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products);
      this.submitBtn = form.querySelector(selectors.checkoutBtn);
  
      this.discounts = form.querySelector(selectors.discounts);
      this.mobileCheckoutButton = form.querySelector(selectors.mobileCheckoutButton);
      this.desktopCheckoutButton = form.querySelector(selectors.desktopCheckoutButton);
      this.savings = form.querySelector(selectors.savings);
      //this.subtotal = form.querySelectorAll(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      //this.noteInput = form.querySelector(selectors.cartNote);
  
      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }
  
      this.init();
    }
  
    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.initQtySelectors();
  
        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));
  
        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

        var scrollContainer = document.querySelector('#CartDrawer .drawer__inner .drawer__scrollable');
        scrollContainer.on('scroll', this.onCartDrawerScroll.bind(this));
        //scrollContainer.dispatchEvent(new CustomEvent('scroll'));

        
        /*
        if (this.noteInput) {
          this.noteInput.addEventListener('change', function() {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }
        */
  
        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function() {
          this.buildCart();
        }.bind(this));
      },
  
      reInit: function() {
        this.initQtySelectors();
      },

      onCartDrawerScroll(evt) {
        var container = evt.target;
        var stickyButton, selector;

        //show/hide mobile sticky
        /*
        selector = '.cart__checkout-mobile [data-sticky-checkout-btn]';
        stickyButton = this.form.querySelector(selector);
        if (checkVisible(container.querySelector('#choose-your-charity-select'))) {
          $(selector).slideUp();
        } else {
          $(selector).slideDown();
        }
        */

        //show/hide desktop sticky
        selector = '.cart__checkout-desktop [data-sticky-checkout-btn]';
        stickyButton = this.form.querySelector(selector);        
        if (checkVisible(container.querySelector('.drawer__footer-main .cart__shipping_msg'))) {
          $(selector).slideUp();
        } else {
          $(selector).slideDown();
        }

        
        
      },
      
      onSubmit: function(evt) {
        //this.submitBtn.classList.add(classes.btnLoading);
  
        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {

            var container = document.querySelector('#CartDrawer .drawer__inner .drawer__scrollable');
            var element = document.querySelector('#CartDrawer .drawer__inner .drawer__scrollable .cart__terms').previousElementSibling;
            container.scrollTop = element.offsetTop - container.offsetTop;

            alert('You must agree with the shipping conditions to check out.');
            //alert(theme.strings.cartTermsConfirmation);
            //this.submitBtn.classList.remove(classes.btnLoading);

            evt.preventDefault();            
            return false;
            
          }
        }
      },
  
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        return {
          items: doc.querySelector('.cart__items'),
          //discounts: doc.querySelector('.cart__discounts')
          stickyCheckoutButton: doc.querySelector('[data-sticky-checkout-btn]'),
          kits: doc.querySelector('.cart-kits'),
          addons: doc.querySelector('.cart-addons')
        }
      },
  
      buildCart: function(detail) {
        theme.cart.getCartProductMarkup()
          .then(this.cartMarkup.bind(this))
          .then(
            function(detail) {
              if (detail) {
                setTimeout(function() {
                  if (detail.addToCartBtn) {
                    document.dispatchEvent(new CustomEvent('cart:open'));
                  }
                }, 250);
              }
            }(detail)
          );
        
        theme.cart.getCart().then(function(response) {
          
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
              cart: response
            }
          }));
          
        });
        
      },
  
      cartMarkup: function(html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;

        //this.updateCartDiscounts(markup.discounts);
  
        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }
  
        this.updateCount(count);
  
        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);

        this.updateSubtotal(subtotal);
        this.updateSavings(savings);
        this.updateSubtotalPlusSavings(subtotal,savings)

        this.updateMobileCheckoutButton(markup.stickyCheckoutButton);
        //this.updateDesktopCheckoutButton(markup.stickyCheckoutButton);

        //this.updateGiftNote(items);

        this.updateKits(markup.kits)
        this.updateAddons(markup.addons)
        
        this.reInit();
  
        if (window.AOS) { AOS.refreshHard() }
  
        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }

      },
  
      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function() {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },
  
      quantityChanged: function(evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];
  
        if (!key || qty < 0) {
          return;
        }
  
        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }


        theme.cart.changeItem(key, qty)
          .then(function(cart) {

            if (cart.item_count == 1 && cart.items[0].handle == 'gift-note') {
              theme.cart.changeItem(cart.items[0].key, 0);
              cart.item_count = 0;
            }

            if (cart.item_count > 0) {
              this.wrapper.classList.remove('is-empty');
              this.buildCart();
            } else {
              this.wrapper.classList.add('is-empty');
            }
  
  
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            }));
            
          }.bind(this))
          .catch(function(XMLHttpRequest){});
      },
  
      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function(subtotal) {
        //this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        this.form.querySelectorAll(selectors.subTotal).forEach((el) => {
          
            el.innerHTML = theme.Currency.formatMoney(subtotal, "${{amount}}").replace(/\.00$/,'');
          
        });

        
      },
/*
      updateGiftNote: function(items) {
        var selector = '#CartDrawer .gift-note-buttons';
        $(selector).show();        
        if (items.item_count > 1 && (items.filter(i => i.handle === 'gift-note').length > 0) ) {
            $(selector).hide();
        } else {
            $(selector).show();          
        }        
      },
      */
      updateSavings: function (savings) {
        this.form.querySelectorAll(selectors.savings).forEach((el) => {
          
          el.innerHTML =  theme.Currency.formatMoney(savings, theme.settings.moneyFormat).replace(/\.00$/,'');
          if (savings > 0) {
            el.parentElement.style.removeProperty('display');
          } else {
            el.parentElement.style.display = "none";
          }
          
        });
        
      },
      
      updateSubtotalPlusSavings(subtotal,savings) {
        
        this.form.querySelectorAll(selectors.subTotalPlusSavings).forEach((el) => {
          el.innerHTML = theme.Currency.formatMoney(parseInt(subtotal) + parseInt(savings), theme.settings.moneyFormat).replace(/\.00$/,'');
          if (savings > 0) {
            el.style.removeProperty('display');
          } else {
            el.style.display = "none";
          }
          
        });
        
      },
      
      updateMobileCheckoutButton: function(markup) {
          if (!this.mobileCheckoutButton) {
          return;
        }
        this.mobileCheckoutButton.innerHTML = markup.innerHTML;
      },
      
      updateKits: function(markup) {

        if ($(selectors.kits).length > 0) {
          if ( markup && markup.hasChildNodes()) {
            $(selectors.kits).replaceWith(markup);
            $('.cart-kits-container').show();            
          } else {
            $('.cart-kits-container').hide();
          }
        }
        document.dispatchEvent(new CustomEvent('kits:updated'));
      },
      
      updateAddons: function(markup) {

        if ($(selectors.addons).length > 0) {

          //compare the new ones to the old, if they haven't changed then don't replace
         /*
          let currentAddons = [];
          $(selectors.addons).find('.cart-addon').each(function() {
              currentAddons.append($(this).attr('class'));
          });
          let newAddons = [];
           $(markup).find('.cart-addon').each(function() {
              newAddons.append($(this).attr('class'));
          });
          if ( currentAddons.sort().join(',') == newAddons.sort().join(',') ) return;
         */

          //update or hide
          if ( markup && markup.hasChildNodes()) {
            $(selectors.addons).replaceWith(markup);
            $('.cart-addons-container').show();            
          } else {
            $('.cart-addons-container').hide();
          }
          
        }
        document.dispatchEvent(new CustomEvent('addons:updated'));
      },
      /*
      updateDesktopCheckoutButton: function(markup) {
          if (!this.desktopCheckoutButton) {
          return;
        }
        this.desktopCheckoutButton.innerHTML = markup.innerHTML;
      },
      */
  
      updateCount: function(count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');
  
        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }
  
        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });
  
    return CartForm;
  })();


  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
  
        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }
  
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
  
      // No ID, bail
      if (!moduleId) {
        return;
      }
  
      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
  
      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var totalHeight = isOpen
                          ? parentCollapsibleEl.offsetHeight - childHeight
                          : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
  
      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function() {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function() {
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  theme.Drawers = (function() {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.xDown = null;
      this.yDown = null;
      this.touchTimeStamp = null;
  
      this.nodes = {
        page: document.querySelector('#MainContent')
      };
  
      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;
  
      if (!this.drawer) {
        return;
      }
  
      this.init();
    }
  
    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('expanded', 'false'); //openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });

        //close button
        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));

        //close on swipe right
        this.drawer.addEventListener("touchstart", this.handleTouchStart.bind(this));
        this.drawer.addEventListener("touchmove", this.handleTouchMove.bind(this));
        this.drawer.addEventListener("touchend", this.handleTouchEnd.bind(this));
        
        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', function() {
          this.close();
        }.bind(this));

        //this storage value can be used to force the drawer to open immediately after a page refresh
        if (localStorage.getItem('loginPopupDrawerState') == 'open') {
          this.open();
          localStorage.removeItem('loginPopupDrawerState');   
        }
        
      },
            
      getTouches: function(evt) {
        return evt.touches ||                      // browser API - touchMove
               evt.originalEvent.touches;          // jQuery - touchMove
      }, 
            
      handleTouchStart: function(evt) {
          const firstTouch = this.getTouches(evt)[0];                                      
          this.xDown = firstTouch.clientX;                                      
          this.yDown = firstTouch.clientY;
          this.tDown = evt.timeStamp;
      },                                            
      
      handleTouchMove: function(evt) {

        if (evt.target.closest('.flickity-enabled') != null)
          return;
        
          var xMin = 100;  //min swipe length in px
          var tMax = 500; //max swipe time in ms
          var yMax = 20;  //max vertical in px
        
          var xUp = evt.touches[0].clientX;                                     
          var yUp = evt.touches[0].clientY;
          var tUp = evt.timeStamp;
      
          var xDiff = this.xDown - xUp;
          var yDiff = this.yDown - yUp;
          var tDiff = this.tDown - tUp;
        
          //console.log("xDiff = " + xDiff);  
          //console.log("yDiff = " + yDiff);  
          //console.log("tDiff = " + tDiff);  
        
          if ( xDiff < 0 
              && Math.abs( xDiff ) > xMin 
              && Math.abs( tDiff ) < tMax 
              && Math.abs( yDiff) < yMax) {
            this.close();
          }
        
      },
      
      handleTouchEnd: function(evt) {
          /* reset values */
          this.xDown = null;
          this.yDown = null;
          this.tDown = null;
      },
      
      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }

        localStorage.setItem('drawerState', "open");
        
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('expanded', 'true'); //evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('expanded', 'true'); //returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;
  
        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
        
        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
  
        this.bindEvents();
      },
  
      close: function(evt) {
        if (!this.isOpen) {
          return;
        }
  
        // Do not close if click event came from inside drawer or from Klaviyo popup
        if (evt) {
          if (evt.target.closest('.js-drawer-close') ) {
            // Do not close if clicking within Klaviyo poup
          } else if (evt.target.closest('.needsclick')) {
            return;
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }
        
        localStorage.setItem('drawerState', "close");
  
        // deselect any focused form elements
        document.activeElement.blur();
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);
  
        window.setTimeout(function() {
          document.documentElement.classList.remove(this.config.closingClass);
          /*
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }*/
          if (this.activeSource && this.activeSource.getAttribute('expanded')) {
            this.activeSource.setAttribute('expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);
  
        this.isOpen = false;
  
        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
          
        this.unbindEvents();
      },
  
      bindEvents: function() {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function(evt) {
          this.close(evt)
          return;
        }.bind(this));
  
        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
  
        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },
  
      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);
  
        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });
  
    return Drawers;
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('expanded', 'false'); //btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('expanded', 'true'); //this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.modal.classList.add(this.config.openClass);
  
      document.documentElement.classList.add(...this.config.bodyOpenClass);
  
      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
  
      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        /*
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
        */
        if (this.activeSource && this.activeSource.getAttribute('expanded')) {
          this.activeSource.setAttribute('expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };
  
    return Modal;
  })();

  // theme.AjaxProduct = (function() {
  //   var status = {
  //     loading: false
  //   };
  // 
  //   function ProductForm(form, submit, args) {
  //     this.form = form;
  //     this.args = args;
  // 
  //     var submitSelector = submit ? submit : '.add-to-cart';
  // 
  //     if (this.form) {
  //       this.addToCart = form.querySelector(submitSelector);
  //       this.form.addEventListener('submit', this.addItemFromForm.bind(this));
  //     }
  //   };
  // 
  //   ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
  //     addItemFromForm: function(evt, callback){
  //       evt.preventDefault();
  // 
  //       if (status.loading) {
  //         return;
  //       }
  // 
  // 
  //       //var reject = false;
  //       //console.log("AjaxProduct.ProductForm.addItemFromForm");
  // 
  //       // Loading indicator on add to cart button
  //       this.addToCart.classList.add('btn--loading');
  // 
  //       status.loading = true;
  // 
  //       var data = theme.utils.serialize(this.form);
  // 
  //       fetch(theme.routes.cartAdd, {
  //         method: 'POST',
  //         body: data,
  //         credentials: 'same-origin',
  //         headers: {
  //           'Content-Type': 'application/x-www-form-urlencoded',
  //           'X-Requested-With': 'XMLHttpRequest'
  //         }
  //       })
  //       .then(response => response.json())
  //       .then(function(data) {
  //         if (data.status === 422) {
  //           this.error(data);
  //         } else {
  //           var product = data;
  //           this.success(product);
  //         }
  // 
  //         status.loading = false;
  //         this.addToCart.classList.remove('btn--loading');
  // 
  //         // Reload page if adding product from a section on the cart page
  //         if (document.body.classList.contains('template-cart')) {
  //           window.scrollTo(0, 0);
  //           location.reload();
  //         }
  //       }.bind(this));
  //               
  //     },
  // 
  //     success: function(product) {
  //       this.clearFormError();
  // 
  //       document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
  //         detail: {
  //           product: product,
  //           addToCartBtn: this.addToCart
  //         }
  //       }));
  // 
  //       if (this.args && this.args.scopedEventId) {
  //         document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
  //           detail: {
  //             product: product,
  //             addToCartBtn: this.addToCart
  //           }
  //         }));
  //       }
  //     },
  // 
  //     error: function(error) {
  //       if (!error.description) {
  //         console.warn(error);
  //         return;
  //       }
  // 
  //       this.setFormError(error.description);
  // 
  //       document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
  //         detail: {
  //           errorMessage: error.description
  //         }
  //       }));
  // 
  //       if (this.args && this.args.scopedEventId) {
  //         document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
  //           detail: {
  //             errorMessage: error.description
  //           }
  //         }));
  //       }
  //     },
  //     
  //     setFormError(msg) {
  //       this.clearFormError(this.form);
  //       var errorDiv = document.createElement('div');
  //       errorDiv.classList.add('errors', 'text-center');
  //       errorDiv.textContent = msg;
  //       this.form.append(errorDiv);
  //     },
  //     
  //     clearFormError() {
  //       var errors = this.form.querySelector('.errors');
  //       if (errors) {
  //         errors.remove();
  //       }
  //     }
  //     
  //   });
  // 
  //   return ProductForm;
  // })();

  theme.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus',
      remove: '.js-qty__remove'
    };
  
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.remove = el.querySelector(selectors.remove);
      this.minValue = this.input.getAttribute('min') || 0;
  
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };
  
      this.options = Object.assign({}, defaults, options);
  
      this.init();
    }
  
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          var qty = this._getQty();
          const productId = this.plus.dataset?.productId;
          const variantId = this.plus.dataset?.variantId;
          const eventName = this.plus.dataset?.event
          const detail = this.plus.dataset?.eventDetail
          const detailTwo = this.plus.dataset?.eventDetailTwo
          window.sendTrackingEvents(eventName, {event_detail: detail, event_detail_two: detailTwo})
          window.igEvents.push({
            event: 'igAddToCart',
            properties: {
              productVariants: [{
                variantId: variantId,
                productId: productId,
              }],
            },
          });
          this._change(qty + 1);
        }.bind(this));
  
        this.minus.addEventListener('click', function() {
          var qty = this._getQty();
          const eventName = this.minus.dataset?.event
          const detail = this.minus.dataset?.eventDetail
          const detailTwo = this.minus.dataset?.eventDetailTwo
          window.sendTrackingEvents(eventName, {event_detail: detail, event_detail_two: detailTwo})
          this._change(qty - 1);
        }.bind(this));
  
        this.input.addEventListener('change', function(evt) {
          this._change(this._getQty());
        }.bind(this));
        
        this.remove.addEventListener('click', function(evt) {
          evt.preventDefault();
          const eventName = this.remove.dataset?.event
          const detail = this.remove.dataset?.eventDetail
          const detailTwo = this.remove.dataset?.eventDetailTwo
          window.sendTrackingEvents(eventName, {event_detail: detail, event_detail_two: detailTwo})
          this._change(0);
        }.bind(this));
        
      },
  
      _getQty: function() {
        var qty = this.input.value;
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },
  
      _change: function(qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
  
        this.input.value = qty;
  
        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });
  
    return QtySelector;
  })();
  
  theme.initQuickShop = function() {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');
  
    if (!products.length || !theme.settings.quickView) {
      return;
    }
  
    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
    });
  
    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };
  
  theme.preloadProductModal = function(handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';
  
    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');
  
    fetch(url).then(function(response) {
      return response.text();
    }).then(function(html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var div = doc.querySelector('.product-section[data-product-handle="'+handle+'"]');
  
      if (!holder) {
        return;
      }
  
      holder.innerHTML = '';
      holder.append(div);
  
      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);
  
      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);
  
      // Register collapsible elements
      theme.collapsibles.init();
  
      // Register potential video modal links (when video has sound)
      theme.videoModal();
  
      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    });
  }
  
  

  //Generic modals can be applied to anything
  //  - .modal-trigger (trigger button)
  //  - data-modal-id="ModalID"
  //  - data-modal-name="modal-name"
  theme.genericModal = function() {
    var selectors = {
      trigger: '.modal-trigger'
    };

    var triggers = document.querySelectorAll(selectors.trigger);
    if (!triggers.length) {
      return;
    }
    
    var modalID = triggers[0].dataset['modalId']; 
    var modal = new theme.Modals(modalID, modalID);
    
  }
  

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  
  theme.videoModal = function() {
    var youtubePlayer;
  
    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);
  
    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }
  
    var videoHolderDiv = document.getElementById(videoHolderId);
  
    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });
  
    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });
  
    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });
  
    document.addEventListener('modalClose.VideoModal', closeVideoModal);
  
    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);
  
      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');
  
      videoHolderDiv.append(playerClone);
      modal.open(evt);
  
      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }
  
    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }
  
    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };

  theme.FilterDrawer = (function() {

    var selectors = {
      drawer: "#FilterDrawer"
    };
    function FilterDrawer() {

      this.drawer = new theme.Drawers('FilterDrawer', 'filters');
      this.init();
    }

    
    FilterDrawer.prototype = Object.assign({}, FilterDrawer.prototype, {
      init: function() {

        document.addEventListener('drawerOpen.FilterDrawer', function(evt) {
          //console.log('drawerOpen.FilterDrawer');
          //var scrollContainer = document.querySelector('#CartDrawer .drawer__inner .drawer__scrollable');
          //scrollContainer.dispatchEvent(new CustomEvent('scroll'));
        }.bind(this));
        
      },
      
     open: function() {
        this.drawer.open();
      },
  
      close: function() {
        this.drawer.close();
      },
    });    
    return FilterDrawer;
  })();
  
  // theme.CartDrawer = (function() {
  //   var selectors = {
  //     drawer: '#CartDrawer',
  //     form: '#CartDrawerForm',
  //     addToCartButton: ".add_to_cart_btn",
  //     productLoopATC: ".product_loop_atc"
  //   };
  // 
  //   function CartDrawer() {
  //     
  //     this.form = document.querySelector(selectors.form);
  //     this.drawer = new theme.Drawers('CartDrawer', 'cart');
  // 
  //     this.init();
  //   }
  // 
  //   
  //   CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
  //     init: function() {
  //       this.cartForm = new theme.CartForm(this.form);
  //       this.cartForm.buildCart();
  // 
  //       
  //       document.addEventListener('ajaxProduct:added', function(evt) {
  //         //console.log('ajaxProduct:added');
  //         this.cartForm.buildCart(evt.detail);
  //         //this.open();
  //       }.bind(this));
  //       
  //       document.addEventListener('cart:updated', function(evt) {          
  //         //console.log('cart:updated');
  //         var count = evt.detail.cart.item_count;
  //         $(".nav-bag-count").html('');
  //         if (count == 0) {
  //           $(".nav-bag-count").removeClass("active");
  //         } else {
  //           $(".nav-bag-count").html(count);
  //           $(".nav-bag-count").addClass("active");
  //         }
  // 
  //         this.resetGiftNote(evt.detail.cart);
  // 
  //         
  //       }.bind(this));
  // 
  //       document.addEventListener('drawerOpen.CartDrawer', function(evt) {
  //         console.log('drawerOpen.CartDrawer');
  //         var scrollContainer = document.querySelector('#CartDrawer .drawer__inner .drawer__scrollable');
  //         scrollContainer.dispatchEvent(new CustomEvent('scroll'));
  //       }.bind(this));
  //       
  //       // Dev-friendly way to open cart
  //       document.addEventListener('cart:open', this.open.bind(this));
  //       document.addEventListener('cart:close', this.close.bind(this));
  // 
  //       this.initGiftNote();
  //       
  //     },
  // 
  //     open: function() {
  //       this.drawer.open();
  //     },
  // 
  //     close: function() {
  //       this.drawer.close();
  //     },
  // 
  //     resetGiftNote: function(cart) {
  //       var selectors = {
  //         gift_note_container: '#CartDrawer .gift-note-buttons',
  //         gift_checkbox: '#CartDrawer #gift',
  //         gift_note: '#CartDrawer #gift_details',
  //         gift_message: '#CartDrawer #gift_message'
  //       };
  // 
  //       $(selectors.gift_checkbox).prop("checked", false);
  //       $(selectors.gift_message).val("");        
  //       $(selectors.gift_note).hide();
  //       if (cart.item_count > 1 && (cart.items.filter(i => i.handle === 'gift-note').length > 0) ) {
  //         $(selectors.gift_note_container).hide();
  //       } else {
  //           $(selectors.gift_note_container).show();          
  //       }
  // 
  //     },
  //     
  //     initGiftNote: function() {
  // 
  //       var selectors = {
  //         gift_note_container: '#CartDrawer .gift-note-buttons',
  //         gift_checkbox: '#CartDrawer #gift',
  //         gift_note: '#CartDrawer #gift_details',
  //         gift_message: '#CartDrawer #gift_message',
  //         add_gift_note_btn: '#CartDrawer #add-gift-note',
  //         gift_note_variant_id: '#CartDrawer #gift-note-variant-id'
  //       };
  //       
  //       $(selectors.gift_message).change(function(event){    
  //         var str = $(event.target).val();
  //         var newstr = theme.utils.removeInvalidChars($(this).val());
  //         if (str != newstr) {
  //           alert('Gift notes can only include alphanumeric characters and punctuation (no emojis).');
  //         }
  //         $(event.target).val(newstr);
  //       }).bind(this);
  // 
  //       $(selectors.gift_checkbox).change(function(event){
  //         if(this.checked){
  //             $(selectors.gift_note).show();
  //         } else {
  //             $(selectors.gift_note).hide();
  //         }
  //       });
  //       
  //       $(selectors.add_gift_note_btn).on('click',function(event) {
  //           event.preventDefault();
  //           if($(selectors.gift_message).val() == '' || $(selectors.gift_message).val() == null){
  //             alert("You must include a message in order to add a gift note.");
  //           } else {
  // 
  //             jQuery.ajax({
  //               type: "POST",
  //               url: '/cart/add.js',
  //               data: {
  //                     quantity: 1,
  //                     id: $(selectors.gift_note_variant_id).val(),
  //                     note: $(selectors.gift_message).val(),
  //                     properties: {
  //                       Message: $(selectors.gift_message).val()
  //                     }
  //                 },
  //               async: false                  
  //             });
  //             setTimeout(function() {
  //               document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
  //                 detail: {
  //                   addToCartBtn: event.target
  //                 }
  //               }));
  //               $(selectors.gift_note_container).hide();
  //              }, 200);
  //           }
  //       });
  //       
  //     }
  //     
  //   });
  // 
  //   return CartDrawer;
  // })();

  
  theme.HeaderSection = (function() {
  
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
  
      this.init();
    }
  
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
  
        this.initDrawers();

      },
  
      initDrawers: function() {
       
        // if (theme.settings.cartType === 'drawer') {
        //   if (!document.body.classList.contains('template-cart')) {
        //     new theme.CartDrawer();
        //   }
        // }
  
      },
  
      onBlockSelect: function(evt) {
      },
  
      onBlockDeselect: function() {
      },
  
      onUnload: function() {

      }
    });
  
    return HeaderSection;
  })();

  // data-section-type="product"
  theme.Product = (function() {
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };
  /*
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]'
    };*/
  
    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      //var productId = this.productId = container.getAttribute('data-product-id');
  
      this.inModal = (container.dataset.modal === 'true');
      this.modal;
  
      this.settings = {
        /*
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
        */
      };
  
      // Overwrite some settings when loaded in modal
      /*
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }*/
  
      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        //form: '.product-single__form',
        form: '#add-item-form',
        //form: '#bundle-form',
  
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',
  
        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',
  
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
  
        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
  
        availabilityContainer: '[data-store-availability-holder]'
      };
  
      this.cacheElements();
  
  
      this.init();
    }
  
    Product.prototype = Object.assign({}, Product.prototype, {
      init: function() {

          this.formSetup();
          this.productSetup();

      },
  
      cacheElements: function() {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),

        };
      },
  
      formSetup: function() {
        this.initAjaxProductForm();
      },
  
  
      productSetup: function() {

      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          // new theme.AjaxProduct(this.cache.form);
        }
      },
      
    });
  
    return Product;
  })();

  
  theme.ButtonAnimations = function() {
    var selectors = {
      buttons: '.btn-animate-js'
    };

    //this will keep the event active when the sticky button is refreshed dynamically
    /*
    $('[data-sticky-checkout-btn]').on('click', '.btn-animate', function() {
      buttonPress($(this)); 
      setTimeout(buttonRedirect, 300, $(this) );
    });
    */
 
    $(selectors.buttons).bind('click', function(e) { 
      buttonPress($(this)); 
      if (getHref($(this))!="") e.preventDefault();      
      setTimeout(buttonRedirect, 300, $(this) );
    });
    
    $(selectors.buttons).keydown(function(evt) {
      if (/^(13)$/.test(evt.which)) {
        buttonPress($(this)); 
        if (getHref($(this))!="") e.preventDefault();
        setTimeout(buttonRedirect, 300, $(this) );
      }
    });
    
    function buttonPress(target) {
      target.addClass("pressed");
    }    
    
    function buttonRelease(target) {
      target.removeClass("pressed");      
    } 
    
    function buttonRedirect(el) {
      buttonRelease(el);

      let href = getHref(el);
      if (href!="") setTimeout(redirect, 300, href);
      
    }
    function getHref (el) {
      //get the href value from the element or ancestor
      if (el.nodeName == "A" && el.attr("href") != "" && !el.attr("href").startsWith("#") ) {
        return el.attr("href");
      } else {
        let parentAnchor = el.closest("a");
        if (parentAnchor && parentAnchor.attr("href") != null && !parentAnchor.attr("href").startsWith("#") )  {
          return parentAnchor.attr("href");
        }
      }
      return "";      
    }
    
    function redirect(href) {
      window.location = href;             
    }
    
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  
  // Trigger events when going between breakpoints
  /*
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });
  */

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function() {
    theme.collapsibles.init();
    
    //theme.videoModal(); //this will turn all video links into modals, but we are probably missing some dependancies
    
    theme.genericModal();
    
    theme.ButtonAnimations();
  }

  DOMready(function(){
    theme.sections = new theme.Sections();

    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    
    new theme.FilterDrawer();

    theme.initGlobals();
    //theme.initQuickShop();

    /*
    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }*/

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });

})();
